import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { routes } from '@platform/core/lib/routes';
import type { INewRecordNavState } from './INewRecordNavState';
import { NEW_RECORD_ID } from './newRecordId';
import { isSplitHost, SPLIT_DRAFT_PARAM } from './splitDraftHosts';

/**
 * Відкрити повну форму нового запису (прототип v4 createRecord → сторінка запису в режимі редагування): перехід на …/<сутність>/new з наперед
 * заданими значеннями й адресою поточної сторінки (туди повертає «Скасувати»). Поки відкрито розділений вигляд типу — чернетка
 * відкривається в його правій панелі (`?new=1`, прототип createRecord(…, 'split')).
 */
export function useOpenNewRecord(): (moduleKey: string, rtKey: string, preset?: Record<string, unknown> | null) => void {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  return useCallback((moduleKey, rtKey, preset) => {
    const state: INewRecordNavState = { preset: preset ?? null, from: `${pathname}${search}` };
    if (!isSplitHost(rtKey)) { navigate(routes.record(moduleKey, rtKey, NEW_RECORD_ID), { state }); return; }
    const params = new URLSearchParams(search);
    params.set(SPLIT_DRAFT_PARAM, '1');
    navigate({ pathname, search: `?${params.toString()}` }, { state });
  }, [navigate, pathname, search]);
}
